import React, { useEffect, useState } from "react";

import "./App.css";

import { api } from "./Api/api";
import { validateForm } from "./Helpers/Validade";

import InputSelect from "./Components/InputSelect/InputSelect";
import InputText from "./Components/InputText/InputText";
import ModalTempoReal from "./Components/ModalTempoReal/ModalTempoReal";
import ModalPeriodo from "./Components/ModalPeriodo/ModalPeriodo";
import ModalColabora from "./Components/ModalColabora/ModalColabora";

const App = () => {
  const [form, setForm] = useState(null);
  const [typeConsult, setTypeConsult] = useState("tempo-real");
  const [inputDateStart, setInputDateStart] = useState(null);
  const [inputDateEnd, setInputDateEnd] = useState(null);
  const [modalTimeRealVisible, setModalTimeVisible] = useState(false);
  const [modalTimeCourse, setModalTimeCourse] = useState(false);
  const [modalColabora, setModalColabora] = useState(false);
  const [mensagemErrorStart, setMensagemErrorStart] = useState("");
  const [erroPreencherStart, setErroPreencherStart] = useState(false);
  const [mensagemErrorEnd, setMensagemErrorEnd] = useState("");
  const [erroPreencherEnd, setErroPreencherEnd] = useState(false);
  const [errorForm, setErrorForm] = useState(true);

  const [uf, setUF] = useState("");
  const [DDD, setDDD] = useState([]);
  const [cidade, setCidade] = useState([]);

  const [loadDDD, setLoadDDD] = useState(false);
  const [loadCity, setLoadCity] = useState(false);

  const [valueModal, setValueModal] = useState(null);

  useEffect(() => {
    setInputDateStart(document.getElementById("data-inicio"));
    setInputDateEnd(document.getElementById("data-fim"));
    setForm(document.getElementById("formulario"));
  }, []);

  useEffect(() => {
    document.getElementById("data-inicio").addEventListener(
      "change",
      (e) => {
        let target = e.target;

        if (target.value !== "") {
          setMensagemErrorStart("");
          setErroPreencherStart(false);
        }
      },
      false
    );

    document.getElementById("data-fim").addEventListener(
      "change",
      (e) => {
        let dateStart = document.getElementById("data-inicio");
        let target = e.target;

        if (dateStart.value === "") {
          setMensagemErrorStart("Preencha esse campo primeiro");
          setErroPreencherStart(true);
          target.value = "";
          return;
        }

        let parseDateStart = Date.parse(dateStart.value);
        let dateStartValue = new Date(parseDateStart);
        let parseDateEnd = Date.parse(target.value);
        let dateStartEnd = new Date(parseDateEnd);

        if (dateStartEnd.getTime() >= dateStartValue.getTime()) {
          setMensagemErrorEnd("");
          setErroPreencherEnd(false);
        } else {
          target.value = "";
          setMensagemErrorEnd("Data Inválida");
          setErroPreencherEnd(true);
        }
      },
      false
    );
  }, [inputDateStart, inputDateEnd]);

  const handleValidateForm = () =>
    validateForm(document.getElementById("formulario"), setErrorForm);
const scrollup = () =>{
    setModalColabora(true)
     // eslint-disable-next-line no-restricted-globals
     parent.postMessage('scroll', '*');
  } 
  const dateDisabled = () => {
    inputDateStart.value = "";
    inputDateEnd.value = "";

    inputDateStart.setAttribute("disabled", "disabled");
    inputDateEnd.setAttribute("disabled", "disabled");

    inputDateStart.removeAttribute("data-required");
    inputDateEnd.removeAttribute("data-required");

    setTypeConsult("tempo-real");
  };

  const dateActive = () => {
    inputDateStart.removeAttribute("disabled");
    inputDateEnd.removeAttribute("disabled");

    inputDateStart.setAttribute("data-required", "true");
    inputDateEnd.setAttribute("data-required", "true");

    setTypeConsult("periodo");
  };

  const consultar = (event) => {
    event.preventDefault();

    const validate = validateForm(event, setErrorForm, true);
    if (validate.error) return;

    setValueModal(validate.value);

	  setModalTimeCourse(true)

    // Google Tag Manager
    // eslint-disable-next-line no-undef
    dataLayer.push({ 
      event:"formulário-portas-abertas", 
      fluxo: "portais-porta-abertas",
      form: "alertas-tim", 
      estado: uf, 
      ddd: validate.value.ddd, 
      cidade: validate.value.cidade, 
      botao:"consultar-botao"
    });


    // switch (typeConsult) {
    //   case "tempo-real":
    //     setModalTimeVisible(true);
    //     break;
    //   case "periodo":
    //     setModalTimeCourse(true);
    //     break;
    //   default:
    //     console.log("Erro ", typeConsult);
    // }
  };

  const closeModalTimeReal = () => {
    setModalTimeVisible(false);
  };

  const closeModalTimeCourse = () => {
    setModalTimeCourse(false);
  };

  const closeModalColabora = () => {
    setModalColabora(false);
  };

  const searchDDD = async (el) => {
    try {
      let target = el.target;
      let value = target.value;

      if (value === "") {
        setDDD([]);
        setCidade([]);
        return;
      }

      setLoadDDD(true);
      setUF(value);

      let { data } = await api.get(`/uf/${value}`);
      console.log(data);
      let ddd = [];
      data.forEach((item) => {
        ddd.push(item.attributes.codigo);
      });
      console.log(ddd);

      setDDD(ddd);
    } catch (error) {
      console.log(error);
    } finally {
      setLoadDDD(false);
      handleValidateForm();
    }
  };

  const searchCity = async (el) => {
    try {
      let target = el.target;
      let value = target.value;

      if (value === "") {
        setCidade([]);
        return;
      }
      setLoadCity(true);

      let { data } = await api.get(`/cidade?uf=${uf}&ddd=${value}`);

      let city = [];
      data.forEach((item) => {
        city.push(item.attributes.municipio);
      });

      setCidade(city);
    } catch (error) {
      console.log(error);
    } finally {
      setLoadCity(false);
      handleValidateForm();
    }
  };

  return (
    <React.Fragment>
      <div id="App">
        <ModalTempoReal
          visible={modalTimeRealVisible}
          close={closeModalTimeReal}
        />
        <ModalPeriodo
          visible={modalTimeCourse}
          close={closeModalTimeCourse}
          values={valueModal}
        />
        <ModalColabora visible={modalColabora} close={closeModalColabora} />
        <div className="container-iframe">
          <iframe
            title="Mapa Cobertura"
            className="iframe"
            style={{"height": window.innerWidth > 768 ? '0px' : '0px'}}
           // src={`https://${
           //   window.location.hostname.indexOf("tim.img.com.br") > -1
            //    ? "tim.img.com.br"
            //    : "timhml.img.com.br"
           // }/mapa-cobertura/`}
          ></iframe>
        </div>
        <div className="container-geral-formulario">
          <div className="container-formulario">
            <div className="container-top">
              <div className="logo-tim"></div>
              <span className="alertas-top">Alertas</span>
            </div>
            <form id="formulario" onSubmit={consultar}>
              <div className="container-alertas-tim">
                <h3 className="tim-alertas">Alertas TIM</h3>
                <span className="msg-consultas">
                  Consulte otimizações programadas e incidentes em andamento
                  perto de você.
                </span>
              </div>
              <InputSelect
                name={"estado"}
                id={"estado"}
                options={[
                  "AC",
                  "AL",
                  "AP",
                  "AM",
                  "BA",
                  "CE",
                  "DF",
                  "ES",
                  "GO",
                  "MA",
                  "MT",
                  "MS",
                  "MG",
                  "PA",
                  "PB",
                  "PR",
                  "PE",
                  "PI",
                  "RJ",
                  "RN",
                  "RS",
                  "RO",
                  "RR",
                  "SC",
                  "SP",
                  "SE",
                  "TO",
                ]}
                msgOption={"Estado"}
                label={"Selecione o estado"}
                data-required={true}
                onChange={searchDDD}
              />
              <InputSelect
                name={"ddd"}
                id={"ddd"}
                options={DDD}
                msgOption={loadDDD ? "Carregando..." : "DDD"}
                label={"Selecione o DDD"}
                data-required={true}
                onChange={searchCity}
              />
              <InputSelect
                name={"cidade"}
                id={"cidade"}
                options={cidade}
                msgOption={loadCity ? "Carregando..." : "Cidade"}
                label={"Selecione a cidade"}
                data-required={true}
                onChange={handleValidateForm}
              />
              <InputText
                id={"tempo-real"}
                type={"radio"}
                name={"consulta"}
                value={"tempo-real"}
                label={"Consultar em tempo real"}
                containerStyle="container-radio"
                styleInput="input-radio"
                onClick={dateDisabled}
                defaultChecked
              />
              <InputText
                id={"periodo"}
                type={"radio"}
                name={"consulta"}
                value={"periodo"}
                label={"Consultar por período"}
                containerStyle="container-radio"
                styleInput="input-radio"
                onClick={dateActive}
              />
              <div className="container-app-date">
                <InputText
                  type={"date"}
                  id={"data-inicio"}
                  name={"data-inicio"}
                  label={"Data Inicial"}
                  containerStyle="container-date"
                  styleInput="input-date"
                  styleLabel="label-date"
                  disabled={true}
                  error={erroPreencherStart}
                  msgError={mensagemErrorStart}
                />
                <InputText
                  type={"date"}
                  id={"data-fim"}
                  name={"data-fim"}
                  label={"Data Final"}
                  containerStyle="container-date"
                  styleInput="input-date"
                  styleLabel="label-date"
                  disabled={true}
                  error={erroPreencherEnd}
                  msgError={mensagemErrorEnd}
                />
              </div>
              <button
                className={`button-consultar-alertas ${
                  errorForm ? "" : "button-active"
                }`}
              >
                Consultar Alertas
              </button>
            </form>
          </div>
          <div className="container-image">
            <div className="retangulo-tim"></div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default App;
